import api from "@/api/api-v2-config";

export async function getItemReorderingByItemIDAxios(id) {
  return await api.get("items/itemreorderingbyitemid/" + id);
}
export async function addPOByItemIDAxios(id) {
  return await api.post("items/createpobyitemid/" + id);
}
export async function addJCByItemIDAxios(id) {
  return await api.post("items/createjobcarditemid/" + id);
}
